<script>
import { mapGetters } from 'vuex';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator.vue';

export default {
  name: 'ResetButton',
  components: {
    LoadingIndicator,
  },
  props: {
    resetPredictor: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'Predictor/getLoadingStatus',
    }),
  },
};
</script>

<template>
  <button class="predictor__reset" @click.prevent="resetPredictor">
    <span>reset to default</span>
    <LoadingIndicator v-if="isLoading" />
  </button>
</template>
